
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface DeviceState {
  isDeviceEligible: boolean;
}

const initialState: DeviceState = {
  isDeviceEligible: false,
};

const deviceSlice = createSlice({
  name: 'device',
  initialState,
  reducers: {
    setDeviceEligible: (state, action: PayloadAction<boolean>) => {
      state.isDeviceEligible = action.payload;
    },
    resetDeviceState: () => initialState,
  },
});

export const { setDeviceEligible, resetDeviceState } = deviceSlice.actions;
export default deviceSlice.reducer;
